"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridNotificationBoxCloseControl = exports.StyledGridNotificationBoxContent = exports.StyledGridNotificationBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const sizing_1 = require("../../../../../design/constants/sizing");
const base_1 = require("../../../../../design/themes/base");
exports.StyledGridNotificationBox = styled_components_1.default.div `
    flex-grow: 1;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background-color: ${base_1.baseTheme.colorHighlightNotification.var()};
    padding: 0 ${sizing_1.sizing.sizeSpaceS.var()};
    border-bottom: 1px solid ${base_1.baseTheme.colorBorderGrid.var()};
`;
exports.StyledGridNotificationBoxContent = styled_components_1.default.div `
    flex-grow: 1;
    display: flex;
    align-items: center;
`;
exports.StyledGridNotificationBoxCloseControl = styled_components_1.default.button `
    display: flex;
    flex-shrink: 0;
    color: ${base_1.baseTheme.colorControlBorder.var()};
    border: none;
    background: none;
    cursor: pointer;
    width: 16px;
    height: 16px;
    margin: 0;
    padding: 2px;

    svg {
        display: block;
        width: 100%;
        height: 100%;
    }

    &:active,
    &:focus {
        outline: none;
    }
`;
//# sourceMappingURL=GridNotificationBox.styles.js.map